<script>
  export let sunrise;
  export let sunset;

  sunrise = sunrise * 1000
  sunset = sunset * 1000

  let now = Date.now().toString();

  let date = Date.now().toString();
  let version = date.substring(0, date.length - 4);


  let dayLength = (sunset - sunrise) / 60;
  let dayLengthHours = Math.floor(dayLength / 60);
  let dayLengthMinutes = Math.round(dayLength % 60);
  let dayProgress = (now - sunrise) / 60;
  let dayProgressPc = dayProgress / dayLength

  let meterProgress = (dayProgressPc) * 180
  let meterOffset = -90;

  let sunriseHours = new Date(sunrise).getHours().toString().padStart(2, "0")
  let sunriseMinutes = new Date(sunrise).getMinutes().toString().padStart(2, "0")
  let sunsetHours = new Date(sunset).getHours().toString().padStart(2, "0")
  let sunsetMinutes = new Date(sunset).getMinutes().toString().padStart(2, "0")

</script>

  <div class="sunrise">
    日の出<br>
    {sunriseHours}:{sunriseMinutes}
  </div>
  <div class="sunset">
    日の入り<br>
    {sunsetHours}:{sunsetMinutes}
  </div>
  <div class="meter" style="transform: rotate({meterOffset + meterProgress}deg);" />

<style lang="scss">
  .sunrise {
    position: absolute;
    top: 1.5vmin;
    left: 1.5vmin;
    font-size: 3vmin;
  }
  .sunset {
    position: absolute;
    top: 1.5vmin;
    right: 1.5vmin;
    text-align: right;
    font-size: 3vmin;
  }
  .meter {
    position: absolute;
    left: 50%;
    bottom: 0;
    width: 0.4vmin;
    height: 10vmin;
    background-color: white;
    transform-origin: bottom;
    transform: rotate(15deg);
    border-radius: 5px;
    opacity: 0.9;
  }
</style>
